export const ADMIN_LANG = {
	"table.semaphore": "Semafor",
	"semaphore.green": "Nenulová spotřeba v posledních {count}ti dnech",
	"semaphore.orange": "Žádná spotřeba v posledních {count}ti dnech, ale v minulosti byla",
	"semaphore.red": "Nebyla nikdy žádná spotřeba přes API klíče",
	"adminChangeBillingMethodModal.title": "Nastavit způsob platby",
	"adminAdvancedBillingConsentModal.title": "Čestné prohlášení",
	"adminAdvancedBillingConsentModal.activeOn": "Aktivní",
	"adminAdvancedBillingConsentModal.activeOff": "Prošlé",
	"adminAdvancedBillingConsentModal.empty": "Neexistují žádné záznamy",
	"adminChangePlanTypeModal.title": "Přepnout obchodní program",
	"adminChangePlanTypeModal.saveBtn": "Přepnout program",
	"adminChangePlanTypeModal.switchToVIP": "Přepnout na program Na míru",
	"adminChangePlanTypeModal.switchToTechnical": "Přepnout na Technický program",
	"adminChangePlanTypeModal.switchToInternal": "Přepnout na Interní program",
	"adminChangePlanTypeModal.switchToBasic": "Přepnout na Základní program",
	"adminChangeVIPParamsModal.title": "Nastavení parametrů programu Na míru",
	"adminJournalsTable.date": "Datum",
	"adminJournalsTable.user": "Uživatel",
	"adminJournalsTable.table": "Tabulka",
	"adminJournalsTable.action": "Akce",
	"adminJournalsTable.desc": "Podrobnosti",
	"adminJournalsTable.roleAction.title": "Akce historie",
	"adminJournalsTable.roleAction.update": "Změna",
	"adminJournalsTable.roleAction.insert": "Vložení",
	"adminJournalsTable.roleAction.delete": "Smazání",
	"adminJournalsTable.roleAction.all": "Všechny akce",
	"adminNotificationsTable.sentAt": "Odesláno",
	"adminNotificationsTable.notificationType": "Typ",
	"adminNotificationsTable.emailRecipients": "Emaily",
	"adminNotificationsTable.emailSubject": "Předmět",
	"adminNotificationsTable.emailBody": "Zpráva",
	"adminNotificationsTable.showBody": "Zobrazit zprávu",
	"adminProjectNotifications.filter.types.email": "Email příjemce",
	"adminProjectNotifications.type.billingDone": "měsíční uzávěrka",
	"adminProjectNotifications.type.debt": "dluh",
	"adminProjectNotifications.type.debtPaid": "dluh splacen",
	"adminProjectNotifications.type.softLimit": "soft limit",
	"adminProjectNotifications.type.hardLimit": "hard limit",
	"adminProjectNotifications.type.adminSwitch_off": "admin switch vypnut",
	"adminProjectNotifications.type.adminSwitch_on": "admin switch zapnut",
	"adminProjectNotifications.type.userSwitch_off": "uživatelský switch vypnut",
	"adminProjectNotifications.type.userSwitch_on": "uživatelský switch zapnut",
	"adminProjectNotifications.type.freeConsumptionLimit": "spotřebován free limit",
	"adminProjectNotifications.type.notEnoughWalletCredit": "nedostatek kreditu v peněžence",
	"adminProjectNotifications.type.advancedConsentNotValid": "nevalidní prohlášení",
	"adminProjectNotifications.type.advancedToBasicDowngrade": "downgrade na základní plán",
	"adminProjectNotifications.type.expiration": "expirace",
	"adminProjectNotifications.type.bulk": "hromadný email",
	"adminProjectNotifications.type.catalogPublishable": "nepublikovaný katalog",
	"adminProjectNotifications.showBody.title": "Detail zprávy",
	"createNotificationModal.title": "Vytvoření interní notifikace",
	"createNotificationModal.internalNotification": "Interní notifikace",
	"createNotificationModal.date": "Datum notifikace",
	"createNotificationModal.email": "Komu",
	"createNotificationModal.text": "Text notifikace",
	"createNotificationModal.error.text": "Text notifikace nesmí být prázdný",
	"createNotificationModal.error.validTill": "Vyplňte datum notifikace",
	"projectJournalPage.title": "Historie změn",
	"adminSetDebtModal.title": "Ruční nastavení dluhu",
	"adminSetDebtModal.debtRange": "Dluh za období {range}",
	"adminTransactionsTable.projectId": "Id projektu",
	"adminTransactionsTable.requestedAt": "Vytvořeno",
	"adminTransactionsTable.range": "Období",
	"adminTransactionsTable.creditsCharged": "Počet kreditů",
	"adminInternalUsersPage.addUser": "Přidat interního uživatele",
	"adminInternalUsersPage.filter.filterValue": "Filtrovat podle",
	"adminInternalUsersPage.filter.title": "Lokální filtr",
	"adminInternalUsersPage.filter.types.email": "Email",
	"adminInternalUsersPage.filter.types.none": "Žádný",
	"adminInternalUsersPage.roleFilter.all": "Všechny role",
	"adminInternalUsersPage.roleFilter.title": "Role uživatele",
	"adminInternalUsersPage.table.createdAt": "Přidán",
	"adminInternalUsersPage.table.email": "Email",
	"adminInternalUsersPage.table.id": "Id uživatele",
	"adminInternalUsersPage.table.internalRole": "Interní role",
	"adminInternalUsersPage.table.source": "Zdroj",
	"adminProjectsPage.filter.title": "Lokální filtr",
	"adminProjectsPage.filter.types.activeState": "Aktivní projekty",
	"adminProjectsPage.filter.types.deactiveState": "Neaktivní projekty",
	"adminProjectsPage.filter.types.id": "Id projektu",
	"adminProjectsPage.filter.types.name": "Jméno/popis projektu",
	"adminProjectsPage.filter.types.none": "Žádný",
	"adminServicesPage.addService": "Přidat službu",
	"adminServicesPage.filter.filterValue": "Filtrovat podle",
	"adminServicesPage.filter.title": "Lokální filtr",
	"adminServicesPage.filter.types.backend": "Jméno backendu",
	"adminServicesPage.filter.types.none": "Žádný",
	"adminServicesPage.table.callPrice": "Cena za volání",
	"adminServicesPage.table.serviceType": "Typ",
	"adminServicesPage.table.hiddenForUsers": "Skrýt uživatelům",
	"adminServicesPage.table.regularService": "Běžně dostupná služba",
	"adminServicesPage.table.rootServiceId": "Root id",
	"adminServicesPage.table.id": "Id služby",
	"adminServicesPage.table.service": "Backend",
	"adminProjectsPage.currentMonthAmountBilled": "Aktuálně placená částka",
	"adminProjectsPage.previousMonthAmountBilled": "Minulá částka",
	"allProjectsPage.filter.vip0": "VIP0",
	"allProjectsPage.filter.approvedAdvancedPlan.title": "Zvýhodněný tarif",
	"allProjectsPage.filter.approvedAdvancedPlan.on": "Schválený",
	"allProjectsPage.filter.approvedAdvancedPlan.off": "Neschválený",
	"allProjectsPage.filter.archived.title": "Dle archivu",
	"allProjectsPage.filter.archived.on": "Archivované",
	"allProjectsPage.filter.archived.off": "Nearchivované",
	"jsonViewer.showMore": "Ukázat celé",
	"jsonViewer.hide": "Skrýt",
	"menu.notificationsHistory": "Historie notifikací",
	"bulkEmailModal.title": "Poslat hromadný email",
	"bulkEmailModal.tab1": "Nastavení",
	"bulkEmailModal.tab2": "Čeština",
	"bulkEmailModal.tab3": "Angličtina",
	"bulkEmailModal.subjectCs": "Předmět",
	"bulkEmailModal.subjectEn": "Předmět",
	"bulkEmailModal.bodyCs": "Obsah emailu",
	"bulkEmailModal.bodyEn": "Obsah emailu",
	"bulkEmailModal.scheduleAt": "Čas poslání",
	"bulkEmailModal.testEmail": "Testovací email",
	"bulkEmailModal.preview": "Náhled",
	"bulkEmailModal.testEmail.sended": "Testovací email byl odeslán",
	"bulkEmailModal.bulkEmail.sended": "Hromadný email byl odeslán",
	"bulkEmailModal.send": "Poslat emaily",
	"bulkEmailModal.sendTest": "Poslat testovací email",
	"bulkEmailModal.confirm": "Opravdu odeslat?",
	"bulkEmailModal.confirmBtn": "Odeslat hromadný email",
	"bulkEmailModal.error.subject": "Předmět musí mít 5-50 znaků",
	"bulkEmailModal.error.emptyBody": "Obsah musí mít min. 5 znaků",
	"bulkEmailModal.error.bodyMaxLen": "Zpráva má {curCount} znaků ze {maxCount}",
	"bulkEmailModal.infoLine1": "Email se zašle na",
	"bulkEmailModal.infoLine2": "{count} {count, plural, one{projekt} few{projekty} other{projektů}}",
	"bulkEmailModal.optionEnglishCzech": "Anglická verze v češtině",
	"bulkEmailModal.optionInsertEmail": "vložit email do Správy administrátora",
	"emailPreviewModal.title": "Náhled emailu",
	"emailPreviewModal.html": "HTML",
	"projectFilter.basic": "základní",
	"projectFilter.advanced": "zvýhodněný",
	"projectFilter.vip": "na míru",
	"projectFilter.technical": "technický",
	"projectFilter.internal": "interní",
	"projectFilter.billedConsumptionOn": "placený",
	"projectFilter.billedConsumptionOff": "neplacený",
	"projectFilter.vip0": "vip0",
	"projectFilter.archived.on": "archivovaný",
	"projectFilter.archived.off": "nearchivovaný",
	"projectFilter.canConsumeOn": "aktivní",
	"projectFilter.canConsumeOff": "neaktivní",
	"projectFilter.noLimit": "Bez omezení",
	"projectFilter.sortByInternalName": "řazení podle jména ({sort})",
	"projectFilter.sortByCanConsume": "řazení podle statusu projektu ({sort})",
	"projectFilter.sortByBusinessPlanType": "řazení podle obchodního modelu ({sort})",
	"projectFilter.sortByBilledConsumption": "řazení podle placené spotřeby ({sort})",
	"projectFilter.sortByCurrentMonthConsumption": "řazení podle aktuální spotřeby ({sort})",
	"projectFilter.sortByPreviousMonthConsumption": "řazení podle minulé spotřeby ({sort})",
	"projectFilter.sortByLastConsumptionDate": "řazení podle data spotřeby ({sort})",
	"projectFilter.sortByCurrentMonthAmountBilled": "řazení podle aktuálně placené částky ({sort})",
	"projectFilter.sortByPreviousMonthAmountBilled": "řazení podle minulé částky ({sort})",
	"projectFilter.all": "Vše",
	"projectFilter.none": "nezadaný",
	"projectFilter.wallet": "peněženka",
	"projectFilter.sos": "media plán",
	"projectFilter.barter": "barter",
	"projectFilter.billingMethod": "způsob platby {billingMethod}",
	"projectFilter.approvedAdvancedPlanOn": "schválené zvýhodněné tarify",
	"projectFilter.approvedAdvancedPlanOff": "neschválené zvýhodněné tarify",
	"projectFilter.actionRequired": "vyžadována akce",
	"adminEditServiceDialog.title": "Úprava služby",
	"createServiceModal.error.callPrice": "Cena za volání musí být větší nebo rovna 0",
	"createServiceModal.type.endpoint": "Endpoint",
	"createServiceModal.type.root": "Root",
	"createServiceModal.type.emptyRoot": "Prázdné root id",
	"projectSettingsModal.tabs.czech": "Čeština",
	"projectSettingsModal.tabs.english": "Angličtina",
	"projectSettingsModal.tabs.bodyCs": "Obsah zprávy",
	"projectSettingsModal.tabs.bodyEn": "Obsah zprávy",
	"projectSettingsModal.tabs.emptyMessage": "Nejsou dostupné informace o nastavené zprávě",
	"projectSettingsModal.tabs.error.emptyBody": "Obsah zprávy musí mít min. 5 znaků",
	"projectSettingsModal.tabs.createdAt": "Zpráva admina vytvořena",
	"projectSettingsModal.tabs.visitedByClientAt": "Zpráva admina shlédnuta klientem",
	"projectSettingsModal.tabs.noVisitedByClient": "Klient zprávu neviděl",
	"projectBusinessPage.title": "Obchod",
	"projectBusinessPage.internalTitle": "Interní popis",
	"projectBusinessPage.comments": "Komentáře",
	"projectBusinessPage.addComment": "Přidat komentář",
	"projectBusinessPage.lastComment": "Poslední editace: {user}, {date}",
	"projectBusinessPage.emptyComments": "Komentáře neexistují",
	"projectBusinessPage.attributes": "Obchodní položky",
	"projectBusinessPage.attributes.approvedAdvancedPlan": "Schválený Zvýhodněný tarif",
	"projectBusinessPage.attributes.approvedAdvancedPlan.off": "Neschválený Zvýhodněný tarif",
	"projectBusinessPage.attributes.approvedAdvancedPlan.values.false": "Neschválený",
	"projectBusinessPage.attributes.approvedAdvancedPlan.values.null": "Nezadáno",
	"projectBusinessPage.attributes.approvedAdvancedPlan.values.true": "Schválený",
	"projectBusinessPage.attributes.actionRequired": "Vyžaduje akci",
	"projectBusinessPage.attributes.actionRequiredText": "ano",
	"projectBusinessPage.attributes.actionRequiredTextAfterDate": "(po {date})",
	"projectBusinessPage.attributes.actionDescription": "Popis akce",
	"projectBusinessPage.attributes.actionEmails": "Seznam emailů",
	"projectBusinessPage.attributes.heliosNumber": "Helios",
	"projectBusinessPage.attributes.orderNumber": "Číslo objednávky",
	"projectBusinessPage.attributes.companyNumber": "IČO",
	"projectBusinessPage.associatedEmails": "Přiřazené emaily",
	"projectBusinessPage.associatedEmails.empty": "Neobsahuje žádné emaily",
	"adminProjectChangeInternalDescModal.title": "Editace popisu",
	"adminProjectChangeInternalDescModal.internalDesc": "Interní popis",
	"adminCommentModal.editTitle": "Editace komentáře",
	"adminCommentModal.newTitle": "Přidat komentář",
	"adminCommentModal.bodyCs": "Obsah komentáře",
	"removeCommentDialog.title": "Smazat komentář",
	"removeCommentDialog.desc": "Opravdu smazat komentář?",
	"adminEditSalesAttributesModal.title": "Editace obchodních položek",
	"adminEditSalesAttributesModal.actionRequired": "Vyžaduje akci",
	"adminEditSalesAttributesModal.actionValidFrom": "Platné od",
	"adminEditSalesAttributesModal.error.actionDescription": "Popis akce musí mít min. 5 znaků",
	"adminEditSalesAttributesModal.error.actionEmails": "Seznam emailů oddělených čárkou",
	"projectDashboardPage.approvalReason": "Důvod",
	"menu.adminCatalogs": "Katalogy",
	"menu.adminApiUsers": "Uživatelé",
	"adminCatalogsPage.published.title": "Publikováno",
	"adminCatalogsPage.published.on": "Publikováno",
	"adminCatalogsPage.published.off": "Nepublikováno",
	"adminCatalogsPage.catalogsCount": "celkem {count} {count, plural, one{katalog} few{katalogy} other{katalogů}}",
	"adminCatalogsPage.approvedByAdmin.title": "Potvrzení adminem",
	"catalogFilter.publishedOn": "publikováno",
	"catalogFilter.publishedOff": "nepublikováno",
	"catalogFilter.quality.interesting": "zajímavá kvalita",
	"catalogFilter.quality.vip": "vip kvalita",
	"catalogFilter.approvedByAdmin.title": "Potvrzení adminem: {msg}",
	"catalogFilter.approvedByAdmin.approved": "Schváleno",
	"catalogFilter.approvedByAdmin.rejected": "Zamítnuto",
	"catalogFilter.approvedByAdmin.undetermined": "Nekontrolováno",
	"catalogFilter.sortByLastUpdate": "řazení podle poslední aktualizace ({sort})",
	"catalogFilter.sortByQuality": "řazení podle kvality fotek ({sort})",
	"catalogFilter.sortByPublished": "řazení podle publikování ({sort})",
	"catalogFilter.sortByApproved": "řazení podle schválení adminem ({sort})",
	"catalogFilter.sortByInternalName": "řazení podle interního jména ({sort})",
	"catalogFilter.sortByPreviousMonthConsumption": "řazení podle minulé spotřeby ({sort})",
	"adminCatalogsTable.preview": "Náhled",
	"adminCatalogsTable.project": "Projekt",
	"adminCatalogsTable.referenceUrl": "Odkaz",
	"adminCatalogsTable.approvedByAdmin": "Schváleno",
	"adminCatalogsTable.publish": "Publikováno",
	"adminCatalogsTable.previousMonthConsumption": "Minulá spotřeba",
	"adminCatalogsTable.lastUpdate": "Poslední aktualizace",
	"banned.yes": "ano",
	"banned.no": "",
	"usersTable.admin.maxProjectCount": "Počet povolených projektů",
	"usersTable.admin.banned": "Zakázaný přístup",
	"adminApiUsersPage.addUser": "Přidat uživatele",
	"adminUserDataModal.title": "Editace uživatele",
	"adminUserDataModal.projectCountDescription": "Poznámka",
	"adminUserDataModal.noteLenError": "Poznámka musí obsahovat {from}-{to} znaků",
	"adminUserDataModal.banned": "Zakázaný přístup",
	"adminUserDataModal.maxProjectCount": "Počet povolených projektů",
	"adminUserDataModal.maxProjectCountError": "Počet zakázaných projektů musí být větší jak 0",
	"adminApiUsersTable.email": "Email",
	"adminApiUsersTable.maxProjectCount": "Počet povolených projektů",
	"adminApiUsersTable.note": "Poznámka",
	"adminApiUsersTable.banned": "Zakázaný přístup",
	"adminApiUsersTable.edit": "Editovat uživatele",
	"adminApiUsersTable.noteBtn": "Spravovat poznámu",
	"adminApiUsersTable.delete": "Odstranit uživatele",
	"removeUserDialog.title": "Smazat doplňkové informace",
	"removeUserDialog.desc": "Opravdu smazat doplňkové informace k uživateli {user}?",
	"adminUserCreateModal.title": "Přidat uživatele",
	"adminUserCreateModal.email": "Email",
	"adminUserCreateModal.emailError": "Email není ve správném formátu",
	"menu.adminQuickComment": "Rychlý komentář",
	"adminQuickCommentPage.comment": "Komentář",
	"adminQuickCommentPage.parse": "Zpracovat",
	"adminQuickCommentPage.results": "Výsledky",
	"adminQuickCommentPage.noRegValues": "Nepodařilo se zparsovat žádná data",
	"adminQuickCommentPage.emptyResponse": "Server nevrátil žádná data",
	"adminQuickCommentPage.minError": "Zpráva musí mít min {count} znaků",
	"adminQuickCommentsTable.value": "Hodnota",
	"adminQuickCommentsTable.type": "Typ",
	"adminQuickCommentsTable.project": "Projekt",
	"adminQuickCommentsTable.type.apiKeyId": "API klíč id",
	"adminQuickCommentsTable.type.apiKeyName": "API klíč jméno",
	"adminQuickCommentsTable.type.email": "E-mail",
	"adminQuickCommentsTable.addComment": "Přidat komentář",
	"projectSettingsPage.consumptionDebt.title": "Konzumace při dluhu v peněžence",
	"projectSettingsPage.consumptionDebt.switch": "Povolit konzumaci při dluhu na peněžence",
	"projectSettingsPage.consumptionDebt.success": "Konzumace při dluhu byla změněna",
	"projectSettingsPage.consumptionDebt.error": "Chyba při změně konzumace dluhu",
	"projectSettingsPage.consumptionDebt.enabled": "Konzumace je povolena",
	"projectSettingsPage.consumptionDebt.disabled": "Konzumace je zakázána",
};
